(function () {
  'use strict';

  if (window.__hhBuyCardLoaded) return;
  window.__hhBuyCardLoaded = true;

  function money(cents, currency) {
    var symbols = { USD: '$', CAD: '$', AUD: '$', NZD: '$', MXN: '$', EUR: '€', GBP: '£', JPY: '¥' };
    return (symbols[currency] || '$') + (Number(cents || 0) / 100).toFixed(2);
  }

  /* The hh_bundle.pricing metafield stores DOLLARS (17.99), while /cart.js and money()
     speak CENTS. Normalise once here so nothing downstream has to remember which is which.
     Without this the card rendered $17.99 as $0.18. */
  function toCents(value) {
    var n = Number(value);
    if (!isFinite(n)) return 0;
    return Math.round(n * 100);
  }

  function normaliseConfig(config) {
    if (!config) return config;
    var i;
    if (config.base_price != null) config.base_price = toCents(config.base_price);
    if (Object.prototype.toString.call(config.tiers) === '[object Array]') {
      for (i = 0; i < config.tiers.length; i += 1) {
        if (config.tiers[i] && config.tiers[i].price != null) {
          config.tiers[i].price = toCents(config.tiers[i].price);
        }
      }
    }
    return config;
  }

  function parseConfig(root) {
    var value;
    try { value = JSON.parse(root.getAttribute('data-config') || 'null'); } catch (error) { value = null; }
    if (typeof value === 'string') {
      try { value = JSON.parse(value); } catch (nestedError) { value = null; }
    }
    return value && typeof value === 'object' ? value : null;
  }

  /* Edge fade shows only while the rail actually has more to scroll to. */
  function bindRailFade(root, wrapClass, discsClass) {
    var wrap = root.querySelector('.' + wrapClass);
    var rail = root.querySelector('.' + discsClass);
    if (!wrap || !rail) return;
    function sync() {
      var more = rail.scrollWidth - rail.clientWidth - rail.scrollLeft > 8;
      if (more) {
        if (wrap.className.indexOf('is-scrollable') < 0) wrap.className += ' is-scrollable';
      } else {
        wrap.className = wrap.className.replace(/\s*is-scrollable/g, '');
      }
    }
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    window.setTimeout(sync, 0);
    sync();
  }

  function init(root) {
    if (!root || root.getAttribute('data-hh-buy-card-ready') === 'true' || !window.HHCartTruth) return;
    root.setAttribute('data-hh-buy-card-ready', 'true');

    var config = normaliseConfig(parseConfig(root));
    var discs = Array.prototype.slice.call(root.querySelectorAll('.hh-bc__disc'));
    var available = [];
    var selected = null;
    var quantity = 1;
    var adding = false;
    var cartState = window.HHCartTruth.get();
    var selectedName = root.querySelector('[data-selected-name]');
    var hero = root.querySelector('[data-hero]');
    var price = root.querySelector('[data-price]');
    var regular = root.querySelector('[data-regular]');
    var shipping = root.querySelector('[data-shipping]');
    var quantityOut = root.querySelector('[data-quantity-out]');
    var add = root.querySelector('[data-add]');
    var hint = root.querySelector('[data-hint]');
    /* addToCart outcomes are staged here instead of written straight to `hint`,
       because render() rewrites hint in every one of its branches and addToCart
       calls render() on the next line, erasing it. render() takes this once at
       the top and clears it, so the message shows in whichever branch renders
       next and never lingers past it. Same idea as `feedback` in
       hh-pack-builder.js. */
    var pendingHint = '';
    var details = root.querySelector('[data-details]');
    var currency = root.getAttribute('data-currency') || 'USD';

    discs.forEach(function (disc) {
      if (disc.getAttribute('data-available') === 'true') available.push(disc);
    });
    /* Deep links decide the colour, not DOM order. Ads and email link to ?variant=<id>, and
       Horizon also server-renders the chosen variant into input[name="id"]. Defaulting to
       available[0] meant a Vibrant Purple link rendered, quoted AND added Black: proved at
       runtime 2026-08-03. Falls back to first available when the requested variant is absent,
       sold out, or not one of this card's discs. */
    function discForVariantId(id) {
      if (!id) return null;
      for (var i = 0; i < available.length; i++) {
        if (String(available[i].getAttribute('data-variant-id')) === String(id)) return available[i];
      }
      return null;
    }
    function requestedVariantId() {
      var match = /[?&]variant=(\d+)/.exec(window.location.search || '');
      if (match) return match[1];
      var initialForm = root.closest ? root.closest('form') : null;
      var idInput = initialForm ? initialForm.querySelector('input[name="id"]') : null;
      return idInput && idInput.value ? idInput.value : null;
    }
    selected = discForVariantId(requestedVariantId()) || (available.length ? available[0] : null);

    function validNumber(value) { return typeof value === 'number' && isFinite(value) && value > 0; }
    function maxPack() { return config && validNumber(config.max_pack) ? Math.floor(config.max_pack) : 0; }
    function basePrice() { return config && validNumber(config.base_price) ? config.base_price : 0; }
    /* Currency. The hh_bundle.pricing metafield is USD, but the store sells in CAD, JPY and
       others. Printing metafield numbers under a local symbol would quote the wrong amount, so
       the tier is converted to a PERCENTAGE off base and applied to Shopify's own presentment
       price (product.price, already in the shopper's currency). Ported from hh-purchase-rail.js
       packTotal(). Falls back to the USD metafield only if the local price is unreadable. */
    var localBaseCents = Number(root.getAttribute('data-local-base-cents')) || 0;
    function localUnit(tierPriceUsdCents) {
      var usdBase = basePrice();
      if (!localBaseCents || !usdBase) return tierPriceUsdCents;
      if (!validNumber(tierPriceUsdCents)) return localBaseCents;
      var percentage = Number(((1 - tierPriceUsdCents / usdBase) * 100).toFixed(4));
      if (percentage <= 0) return localBaseCents;
      return localBaseCents - Math.round(localBaseCents * percentage / 100);
    }
    function localBase() { return localBaseCents || basePrice(); }


    function headroom() { return Math.max(0, maxPack() - (Number(cartState.qty) || 0)); }
    function tierFor(total) {
      var tiers = config && Array.isArray(config.tiers) ? config.tiers : [];
      var index;
      var tier;
      var maximum;
      for (index = 0; index < tiers.length; index += 1) {
        tier = tiers[index];
        maximum = tier && (tier.max === null || typeof tier.max === 'undefined') ? Infinity : Number(tier && tier.max);
        if (tier && validNumber(tier.price) && Number(tier.min) <= total && total <= maximum) return tier;
      }
      return null;
    }
    function setAddDisabled(disabled) {
      if (add) add.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    }
    function setDiscState() {
      discs.forEach(function (disc) {
        var active = disc === selected;
        disc.setAttribute('aria-checked', active ? 'true' : 'false');
        disc.setAttribute('tabindex', active ? '0' : '-1');
      });
    }
    var placement = root.getAttribute('data-placement') || 'homepage';
    var shopSlot = root.querySelector('[data-shop-row]');
    var swapToken = 0;

    /* Ported from hh-purchase-rail.js swapPdpGallery. On the PDP this card renders no media of
       its own, so selecting a colour has to move Horizon's gallery or the shopper buys Blue
       while looking at a Black photo. */
    function swapPdpGallery(disc) {
      if (placement !== 'pdp' || !disc) return;
      var next = disc.getAttribute('data-hero') || disc.getAttribute('data-image') || '';
      if (!next) return;
      var gallery = document.querySelector('.product-media-container, media-gallery, slideshow-component');
      if (!gallery) return;
      var img = gallery.querySelector('img');
      if (!img) return;
      var token = ++swapToken;
      var preload = new Image();
      preload.onload = function () {
        if (token !== swapToken) return;
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = next;
        img.alt = (disc.getAttribute('data-name') || '') + ' Hit Hero';
      };
      preload.src = next;
      var slideshow = document.querySelector('slideshow-component');
      if (slideshow && typeof slideshow.select === 'function') {
        try { slideshow.select(0); } catch (error) { /* gallery differs by theme version */ }
      }
    }

    function moveShopPay() {
      if (placement !== 'pdp' || !shopSlot) return null;
      var form = root.closest ? root.closest('form') : null;
      if (!form) return null;
      var accelerated = form.querySelector('.accelerated-checkout-block');
      if (accelerated && accelerated.parentNode !== shopSlot) shopSlot.appendChild(accelerated);
      return accelerated;
    }

    /* Ported from hh-purchase-rail.js syncShopPay. Shop Pay submits the real form, so the form's
       hidden inputs must carry the selected variant and quantity BEFORE the button is reachable.
       Without this the button expresses-checkout whatever the server rendered, which was one
       Black regardless of what the shopper picked. Fail closed: reveal only after reading the
       values back, and never while an add is already in flight. */
    function syncShopPay() {
      if (placement !== 'pdp') return;
      if (adding) { var busy = moveShopPay(); if (busy) busy.hidden = true; root.className = root.className.replace(/\s*is-shop-ready/g, ''); return; }
      root.className = root.className.replace(/\s*is-shop-ready/g, '');
      var form = root.closest ? root.closest('form') : null;
      var accelerated = moveShopPay();
      if (accelerated) accelerated.hidden = true;
      if (!form || !accelerated || !selected) return;
      if (cartState.status !== 'resolved') return;
      /* Shop Pay express-checks-out ONLY this form's line, so the volume function prices it
         at the single-unit rate. Once guards are already in the cart the card legitimately
         shows the combined-tier price, which would then be LOWER than what express charges.
         Displaying less than we charge is the one rule that cannot bend, so the express path
         is withdrawn whenever it would disagree. Add to Cart stays exact in every state. */
      if ((Number(cartState.qty) || 0) > 0) return;
      if (quantity < 1 || quantity > headroom()) return;

      var idInput = form.querySelector('input[name="id"]');
      var quantityInput = form.querySelector('input[name="quantity"]');
      if (!idInput || !quantityInput) return;
      var wantId = Number(selected.getAttribute('data-variant-id'));
      idInput.value = String(wantId);
      quantityInput.value = String(quantity);
      if (Number(idInput.value) !== wantId || Number(quantityInput.value) !== quantity) return;

      accelerated.hidden = false;
      root.className += ' is-shop-ready';
    }

    var heroToken = 0;
    var warmed = false;
    function warmHeroes() {
      if (warmed) return;
      warmed = true;
      for (var i = 0; i < discs.length; i += 1) {
        var u = discs[i].getAttribute('data-hero');
        if (u) { var img = new Image(); img.src = u; }
      }
    }

    function select(disc) {
      if (!disc || disc.getAttribute('data-available') !== 'true') return;
      selected = disc;
      if (selectedName) selectedName.textContent = disc.getAttribute('data-name') || '';
      if (hero) {
        /* Preload, then swap. Setting src directly left the frame dimmed on a stale image while
           the new one downloaded, which read as a slow, sticky click. A token guards against a
           fast second click landing an earlier image last. */
        var wanted = disc.getAttribute('data-hero') || disc.getAttribute('data-image') || '';
        var name = disc.getAttribute('data-name') || '';
        if (wanted && wanted !== hero.getAttribute('src')) {
          var token = ++heroToken;
          hero.style.opacity = '.35';
          var pre = new Image();
          pre.onload = function () {
            if (token !== heroToken) return;
            hero.src = wanted;
            hero.alt = name;
            hero.style.opacity = '1';
          };
          pre.onerror = function () {
            if (token !== heroToken) return;
            hero.src = wanted;
            hero.alt = name;
            hero.style.opacity = '1';
          };
          pre.src = wanted;
        }
      }
      if (details) details.href = (root.getAttribute('data-product-url') || '') + '?variant=' + disc.getAttribute('data-variant-id');
      swapPdpGallery(disc);
      setDiscState();
      render();
    }
    function setQuantity(next) {
      quantity = Math.max(1, Math.floor(Number(next) || 1));
      if (headroom() > 0) quantity = Math.min(quantity, headroom());
      render();
    }
    function render() {
      window.setTimeout(syncShopPay, 0);
      var staged = pendingHint;
      pendingHint = '';
      var status = cartState && cartState.status;
      var room = headroom();
      var eligible = status === 'resolved' && !!selected && !!basePrice() && room > 0 && quantity <= room && !adding;
      var combined = (Number(cartState.qty) || 0) + quantity;
      var tier = tierFor(combined);
      var unitPrice = localUnit(tier ? Number(tier.price) : basePrice());
      var plus = root.querySelector('[data-quantity="1"]');
      var minus = root.querySelector('[data-quantity="-1"]');
      if (quantityOut) quantityOut.textContent = String(quantity);
      if (plus) plus.setAttribute('aria-disabled', room === 0 || quantity >= room || adding ? 'true' : 'false');
      if (minus) minus.setAttribute('aria-disabled', quantity <= 1 || adding ? 'true' : 'false');
      if (status !== 'resolved') {
        if (price) price.textContent = 'Updating cart';
        if (regular) regular.innerHTML = '&nbsp;';
        if (shipping) { shipping.innerHTML = '&nbsp;'; shipping.className = 'hh-bc__shipping'; }
        if (hint) hint.textContent = staged || (status === 'unresolved' ? 'Cart could not be verified. Refresh to continue.' : 'Updating cart. Add to Cart will be ready in a moment.');
        setAddDisabled(true);
        return;
      }
      if (!selected) {
        if (price) price.textContent = 'Choose an available color';
        if (regular) regular.innerHTML = '&nbsp;';
        if (hint) hint.textContent = staged || 'This product is currently sold out.';
        setAddDisabled(true);
        return;
      }
      if (room === 0) {
        if (price) price.textContent = 'Cart is full';
        if (regular) regular.innerHTML = '&nbsp;';
        if (shipping) { shipping.innerHTML = '&nbsp;'; shipping.className = 'hh-bc__shipping'; }
        if (hint) hint.textContent = staged || 'Your cart already has the maximum pack quantity.';
        setAddDisabled(true);
        return;
      }
      if (!basePrice() || !tier || !validNumber(unitPrice)) {
        if (price) price.textContent = 'Pricing unavailable';
        if (regular) regular.innerHTML = '&nbsp;';
        if (hint) hint.textContent = staged || 'Pricing could not be verified. Please refresh to continue.';
        setAddDisabled(true);
        return;
      }
      if (price) price.textContent = money(unitPrice * quantity, currency);
      if (regular) {
        /* Only strike a price when one is actually being beaten. Showing $17.99 struck
           beside $17.99 reads as a fake discount. */
        if (unitPrice < localBase()) {
          regular.innerHTML = '<span class="hh-bc__sr">Regular price </span><s>' + money(localBase() * quantity, currency) + '</s>';
        } else if (quantity === 1) {
          regular.textContent = 'each';
        } else {
          regular.innerHTML = '&nbsp;';
        }
      }
      if (shipping) {
        if (Number(config.free_shipping_min_qty) > 0 && combined >= Number(config.free_shipping_min_qty)) {
          shipping.textContent = 'Ships free';
          shipping.className = 'hh-bc__shipping is-visible';
        } else {
          shipping.innerHTML = '&nbsp;';
          shipping.className = 'hh-bc__shipping';
        }
      }
      if (hint) hint.textContent = staged || (quantity >= room ? 'Maximum available with your current cart.' : '\u00a0');
      setAddDisabled(!eligible);
    }

    function replaceDrawer(data) {
      var html = data && data.sections && data.sections['cart-drawer-section'];
      var wrap;
      var fresh;
      var drawer;
      if (!html) { window.location.reload(); return false; }
      wrap = document.getElementById('shopify-section-cart-drawer-section');
      fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('shopify-section-cart-drawer-section');
      if (wrap && fresh) wrap.replaceWith(fresh);
      drawer = document.getElementById('cart-drawer');
      if (drawer) {
        if (typeof drawer.open === 'function') drawer.open();
        else drawer.setAttribute('open', '');
      }
      return true;
    }
    function standardCart(cart) {
      var currencyCode = cart && cart.currency ? String(cart.currency) : '';
      return {
        id: cart && cart.token ? String(cart.token) : '',
        totalQuantity: Number(cart && cart.item_count) || 0,
        cost: { totalAmount: { amount: ((Number(cart && cart.total_price) || 0) / 100).toFixed(2), currencyCode: currencyCode } },
        lines: cart && Array.isArray(cart.items) ? cart.items.map(function (item) {
          return { id: String(item.key || item.id || ''), quantity: Number(item.quantity) || 0, cost: { totalAmount: { amount: ((Number(item.final_line_price) || 0) / 100).toFixed(2), currencyCode: currencyCode } } };
        }) : []
      };
    }
    function dispatchCartUpdate(items, data, cart) {
      var detail = { didError: false, itemCount: Number(cart && cart.item_count) || 0, items: cart && cart.items, sections: data.sections, source: 'hh-buy-card' };
      var event = new Event('shopify:cart:lines-update', { bubbles: true });
      event.action = 'add';
      event.context = 'cart';
      event.lines = items.map(function (item) { return { merchandiseId: String(item.id), quantity: item.quantity }; });
      event.detail = { source: 'hh-buy-card' };
      event.promise = Promise.resolve({ cart: standardCart(cart), detail: detail });
      (document.querySelector('#shopify-section-cart-drawer-section cart-items-component') || document).dispatchEvent(event);
    }
    function addToCart() {
      var items;
      /* Once the POST lands, nothing downstream may claim the add failed. The shopper can see
         the item in the drawer, so "that did not go through" reads as a contradiction and
         invites a second add. Verified 2026-08-03: blocking the follow-up /cart.js read left a
         successfully added item on screen under a failure message. */
      var posted = false;
      if (!add || add.getAttribute('aria-disabled') === 'true' || adding || !selected) return;
      adding = true;
      render();
      items = [{ id: Number(selected.getAttribute('data-variant-id')), quantity: quantity }];
      fetch(root.getAttribute('data-cart-add-url'), {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: 'cart-drawer-section', sections_url: window.location.pathname })
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart add failed');
        /* The server has taken the add. Anything that fails from here (a truncated body,
           a failed drawer swap, a failed verification read) must never tell the shopper
           the add did not happen, or they add again and get charged twice. */
        posted = true;
        return response.json();
      }).then(function (data) {
        if (!replaceDrawer(data)) return null;
        return window.HHCartTruth.afterAdd(items).then(function (report) { return { data: data, report: report }; });
      }).then(function (transaction) {
        var result;
        if (!transaction) {
          /* Drawer replacement failed after a successful POST. This used to return without
             clearing `adding`, which left the button disabled for the rest of the session. */
          adding = false;
          pendingHint = 'Added. We could not refresh the cart display, so please review your cart.';
          render();
          return;
        }
        result = transaction.report.variants[0];
        adding = false;
        if (!result || !result.increased) {
          pendingHint = 'The selected color could not be fully added. Please review your cart.';
        } else {
          quantity = 1;
        }
        dispatchCartUpdate(items, transaction.data, transaction.report.state.raw);
        render();
      }).catch(function () {
        adding = false;
        pendingHint = posted
          ? 'Added. We could not refresh the cart display, so please review your cart.'
          : 'That did not go through. Please try again.';
        render();
      });
    }

    discs.forEach(function (disc) {
      disc.addEventListener('click', function () { select(disc); });
      disc.addEventListener('keydown', function (event) {
        var index = available.indexOf(disc);
        var next;
        if (event.keyCode !== 37 && event.keyCode !== 38 && event.keyCode !== 39 && event.keyCode !== 40) return;
        event.preventDefault();
        next = event.keyCode === 37 || event.keyCode === 38 ? index - 1 : index + 1;
        if (next < 0) next = available.length - 1;
        if (next >= available.length) next = 0;
        select(available[next]);
        available[next].focus();
      });
    });
    root.addEventListener('click', function (event) {
      var target = event.target;
      var direction;
      /* === null, not truthiness. A bare `data-add` attribute returns '' which is falsy,
         so the truthy walker climbed straight past the button and Add to Cart did nothing.
         Same bug class as the inert 'Add 1 More' control in July. */
      while (target && target !== root && target.getAttribute('data-quantity') === null && target.getAttribute('data-add') === null) target = target.parentNode;
      if (!target || target === root) return;
      if (target.getAttribute('data-add') !== null) { addToCart(); return; }
      direction = Number(target.getAttribute('data-quantity'));
      if (target.getAttribute('aria-disabled') === 'true') return;
      setQuantity(quantity + direction);
    });
    window.HHCartTruth.subscribe(function (nextState) { cartState = nextState; render(); });
    /* Progressive enhancement, copied from the rail's contract in buy-buttons.liquid: the CSS
       that hides Horizon's native quantity and Add to Cart is gated on this class, which is only
       added once the card has actually booted. If our JS never runs, the native controls stay and
       the shopper can still buy. Horizon's quick-add clones this markup via DOMParser, where
       injected scripts never execute, so an unconditional hide would leave no way to buy at all. */
    var pdpHost = root.parentNode;
    while (pdpHost && pdpHost !== document.body) {
      if (pdpHost.className && String(pdpHost.className).indexOf('hh-pr-host-pdprail') > -1) {
        if (String(pdpHost.className).indexOf('hh-bc-live') < 0) pdpHost.className += ' hh-bc-live';
        break;
      }
      pdpHost = pdpHost.parentNode;
    }
    var discWrap = root.querySelector('.hh-bc__discs');
    if (discWrap) {
      discWrap.addEventListener('touchstart', warmHeroes, { passive: true });
      discWrap.addEventListener('mouseenter', warmHeroes);
      discWrap.addEventListener('focusin', warmHeroes);
    }
    bindRailFade(root, 'hh-bc__discs-wrap', 'hh-bc__discs');
    select(selected);
  }

  function initAll(scope) {
    /* fade state is bound per instance inside init via the call below */
    var context = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(context.querySelectorAll('[data-hh-buy-card]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
}());


/* ---------------------------------------------------------------------------
   Product view tiles (front / rear / side / thumb / index).

   Front, rear and side follow the selected colour; the two photographs do not.

   Three things this has to survive, all found in review:

   1. The colour handler above preloads an Image() and writes hero.src in its
      onload. Tapping a view tile before that resolves used to get overwritten by
      the late write. A MutationObserver on the hero re-asserts the active view,
      so whoever writes last does not win, the selected tile does.
   2. Colour can change by arrow key, which never fires a click. Watching
      aria-checked on the discs catches both paths.
   3. shopify:section:load fires boot() across the document, so a per-card flag
      stops duplicate listeners stacking up.

   Lives in an asset, never inlined: this markup can arrive through the Section
   Rendering API and inline scripts in that HTML never execute.
--------------------------------------------------------------------------- */
(function () {
  function closestEl(node, sel) {
    if (node && node.closest) return node.closest(sel);
    while (node && node.nodeType === 1) {
      if (node.matches ? node.matches(sel) : false) return node;
      node = node.parentNode;
    }
    return null;
  }
  function setOn(el, on) {
    if (on) { el.className = el.className.indexOf('is-on') === -1 ? el.className + ' is-on' : el.className; }
    else { el.className = el.className.replace(/\s*\bis-on\b/g, ''); }
    el.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  function init(root) {
    if (root.getAttribute('data-hh-views-ready') === '1') return;
    var views = root.querySelector('[data-views]');
    if (!views) return;
    var hero = root.querySelector('[data-hero]');
    if (!hero) return;
    root.setAttribute('data-hh-views-ready', '1');

    var tiles = views.querySelectorAll('[data-hh-view]');
    var activeView = 'front';
    var activeUrl = hero.getAttribute('src') || '';

    function currentDisc() {
      return root.querySelector('.hh-bc__disc[aria-checked="true"]') ||
             root.querySelector('.hh-bc__disc');
    }
    function urlFor(view, small) {
      if (view === 'thumb' || view === 'index') {
        var t = views.querySelector('[data-hh-view="' + view + '"]');
        return t ? t.getAttribute('data-photo') : '';
      }
      var d = currentDisc();
      if (!d) return '';
      var big = d.getAttribute('data-' + view);
      var sm = d.getAttribute('data-' + view + '-sm');
      if (view === 'front' && !big) big = d.getAttribute('data-image') || d.getAttribute('data-hero');
      return small ? (sm || big || '') : (big || '');
    }
    function paint(view) {
      var url = urlFor(view, false);
      if (!url) return;
      activeView = view;
      activeUrl = url;
      for (var i = 0; i < tiles.length; i++) {
        setOn(tiles[i], tiles[i].getAttribute('data-hh-view') === view);
      }
      if (hero.getAttribute('src') !== url) hero.src = url;
    }

    views.addEventListener('click', function (e) {
      var t = closestEl(e.target, '[data-hh-view]');
      if (!t || !views.contains(t)) return;
      e.preventDefault();
      paint(t.getAttribute('data-hh-view'));
    });

    /* Re-assert the chosen view if anything else writes to the hero. This is what
       makes the colour preload race harmless. */
    if (window.MutationObserver) {
      new MutationObserver(function () {
        if (activeView === 'front') return;
        var cur = hero.getAttribute('src') || '';
        if (activeUrl && cur !== activeUrl) hero.src = activeUrl;
      }).observe(hero, { attributes: true, attributeFilter: ['src'] });
    }

    /* Colour change, by click or by keyboard. Reset to front and refresh the
       small tile art for the new colour. */
    function onColourChange() {
      activeView = 'front';
      for (var i = 0; i < tiles.length; i++) {
        var v = tiles[i].getAttribute('data-hh-view');
        setOn(tiles[i], v === 'front');
        if (v === 'front' || v === 'rear' || v === 'side') {
          var u = urlFor(v, true);
          var img = tiles[i].querySelector('img');
          if (u && img && img.getAttribute('src') !== u) img.src = u;
        }
      }
      activeUrl = urlFor('front', false) || hero.getAttribute('src') || '';
    }
    if (window.MutationObserver) {
      var discWrap = root.querySelector('.hh-bc__discs') || root;
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].attributeName === 'aria-checked' &&
              muts[i].target.getAttribute('aria-checked') === 'true') {
            onColourChange();
            return;
          }
        }
      }).observe(discWrap, { attributes: true, subtree: true, attributeFilter: ['aria-checked'] });
      /* Sync once for the colour that is ALREADY selected. This script is deferred, so both
         IIFEs run synchronously in source order and the first one has already called select()
         and written aria-checked before this observer exists. The observer therefore never
         fires for the initial selection, and with a deep-linked ?variant= the hero went purple
         while these thumbnails kept the server-rendered first-available colour (black).
         Proved at runtime 2026-08-03 on ?variant=50990569029921. onColourChange reads from
         currentDisc() and is idempotent, so calling it here is safe. */
      onColourChange();
    }
  }

  function boot() {
    /* [class*="hh-buy-card-"] also matches three ancestor wrappers
       (hh-buy-card-section, -section-template--..., -section__wrap), so it bound
       the same tiles four times. data-placement is only on the card root. */
    var cards = document.querySelectorAll('[data-placement]');
    for (var i = 0; i < cards.length; i++) init(cards[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
